import React, { useState, useEffect } from "react";
import styled, { keyframes, css } from "styled-components";
import CO2 from "./assets/images/co2.png";
import Light from "./assets/images/light.png";
import InsideTemp from "./assets/images/insideTemp.png";
import OnLamp from "./assets/images/Lamp.png";
import OffLamp from "./assets/images/offLamp.png";
import Tv from "./assets/images/tv.png";
import Abazhor from "./assets/images/abazhor.png";
import { io } from "socket.io-client";

const Box = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100px",
  width: "100px",
  margin: "5px",
  background: "white",
  transition: "2000ms",
  borderRadius: "15px",
  boxShadow: "0 0 19px 1px rgb(24 23 23 / 20%)",
  cursor: (p) => (p.onClick ? "pointer" : "default"),
  "& img": {
    height: "30px",
    transition: "200ms",
  },
  "& .name": {
    fontFamily: "title",
    marginTop: "5px",
    marginBottom: "0",
    fontSize: "14px",
  },
  "& .value": {
    fontFamily: "title",
    fontSize: "12px",
    color: "gray",
  },
});
const Sc5 = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  flex: 1,
  width: "100%",
  height: "100%",
  background: "var(--back)",

  "& .header": {
    width: "100%",
    height: 60,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    background: "var(--blue)",
    borderBottomLeftRadius: "15px",
    borderBottomRightRadius: "15px",
    boxShadow: "0 0 19px 1px rgb(24 23 23 / 20%)",
    "& span": {
      fontFamily: "title",
      color: "white",
      fontWeight: "bold",
      fontSize: "18px",
      margin: "0 10px ",
      flex: 1,
      textAlign: "center",
    },
  },
  "& .cn": {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    background: "var(--back)",
    width: "calc( 100% - 20px)",
    flexWrap: "wrap",
    padding: "10px",
  },
});

const room = new URLSearchParams(window.location.search).get("q");

const socket = io("https://nirooban.com", { query: { room } });

export default function Demo() {
  const [lamp, setLamp] = useState(false);
  const [tv, settv] = useState(false);
  const [abazhor, setAbazhor] = useState(false);
  const [sensor, setSensor] = useState({ h: 80, c: 10, t: 20 });
  const [lastSend, setLastSend] = useState("000");
  const [effected, setEffected] = useState(false);

  useEffect(() => {
    if (!effected) {
      setEffected(true);
      socket.emit("cmd", { connect: true });
    }
  }, []);

  const send = (item) => {
    let v;
    v = lastSend.split("");
    v[item.item] = item.value ? "0" : "1";
    let sum = v.reduce((acc, cur) => {
      return (acc = acc + parseInt(cur));
    }, 0);
    setSensor({ t: sum*20, c: 20 });
    v = v.join("");
    setLastSend(v);
    socket.emit("cmd", { value: v });
  };
  return (
    <Sc5>
      <div className="header">
        <span>خانه هوشمند</span>
        <i></i>
      </div>
      <div className="cn">
        <Box
          onClick={() => {
            setLamp(!lamp);
            send({ item: 1, value: lamp });
          }}
        >
          <img style={{ opacity: lamp ? "1" : "0.4" }} src={OnLamp} alt="" />
          <span className="name">لامپ</span>
          <span className="value">{lamp ? "روشن" : "خاموش"}</span>
        </Box>
        <Box
          onClick={() => {
            settv(!tv);
            send({ item: 0, value: tv });
          }}
        >
          <img style={{ opacity: tv ? "1" : "0.4" }} src={Tv} alt="" />
          <span className="name">تلویزیون</span>
          <span className="value">{tv ? "روشن" : "خاموش"}</span>
        </Box>
        <Box
          onClick={() => {
            setAbazhor(!abazhor);
            send({ item: 2, value: abazhor });
          }}
        >
          <img
            style={{ opacity: abazhor ? "1" : "0.4" }}
            src={Abazhor}
            alt=""
          />
          <span className="name">آباژور</span>
          <span className="value">{abazhor ? "روشن" : "خاموش"}</span>
        </Box>
        <Box>
          <img src={Light} alt="" />
          <span className="name">میزان نور محیط</span>
          <span className="value">{sensor.t}lux</span>
        </Box>
        <Box>
          <img src={CO2} alt="" />
          <span className="name">میزانCO2</span>
          <span className="value">{sensor.c}ppm</span>
        </Box>
      </div>
    </Sc5>
  );
}
